import { isNavigationFailure, NavigationFailureType } from 'vue-router';

// Vue Router 4.4 does not expose NavigationFailureType.redirected; redirects use
// ErrorTypes.NAVIGATION_GUARD_REDIRECT (2), which is not a public runtime export.
const NAVIGATION_GUARD_REDIRECT = 2;

/**
 * Swallow expected vue-router navigation failures so they are not reported as unhandled errors.
 * @param {unknown} error
 */
export function onError(error) {
  if (
    isNavigationFailure(error, NAVIGATION_GUARD_REDIRECT) ||
    isNavigationFailure(error, NavigationFailureType.duplicated) ||
    isNavigationFailure(error, NavigationFailureType.cancelled)
  ) {
    return;
  }
  throw error;
}
